import * as m from "@/paraglide/messages"
import { AccessDeniedError } from "@/shared/api/errors"
import { showSystemPopup } from "./popup"

export function showServiceErrorPopup(error: unknown): void {
	if (error instanceof AccessDeniedError) return
	void showSystemPopup({
		title: m.serviceErrorTitle(),
		message: m.serviceErrorMessage(),
		buttons: [{ id: "ok", text: m.commonBtnOk(), type: "ok" }],
	})
}
